import { observable, action, runInAction } from 'mobx';
import approvePermissionAPI from '../apis/approvePermissionAPI'
import alertMessage from '../utils/alertMessage'
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';

export default class ApprovePermissionStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    pageNum: 0,
    pageSize: 0,
    status: '0',
    userName: ''
  }
  @observable approveList = []
  @action
  async onSearchApproveAction(params,pageNo,pageSize) {
    this.isFetching = true
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      this.roleList = []
      const response = await approvePermissionAPI.searchApproveAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response?.data?.data?.code === 0) {
          for(var i=0; i<response.data.data.data.length; i++) {
            response.data.data.data[i].status===0?response.data.data.data[i].statusName='Processing':
              response.data.data.data[i].status===1?response.data.data.data[i].statusName='Approved':
                response.data.data.data[i].status===2?response.data.data.data[i].statusName='Rejected':
                  response.data.data.data[i].statusName='Invalid'
          }
          this.approveList = response.data.data.data || []
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  /*add user*/
  @action
  async onAgreeAction(params){
    this.isFetching = true
    try {
      const response = await approvePermissionAPI.agreeAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchApproveAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Error！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*page*/
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageIndex !== pageNo || pageSize !== this.pageSize) {
      runInAction(() => {
        this.pageNo = pageNo
        this.pageSize = pageSize || this.pageSize
      })
      this.onSearchApproveAction(this.searchItem,this.pageNo,this.pageSize)	// 接口不提供分页，前端自己分页
    }
  }
}
